// lib/socket.ts
import { io, Socket } from "socket.io-client";

const WS_CHAT_BASE_URL = process.env.REACT_APP_CELLERA_WS_CHAT_BASE_URL;

let socket: Socket | null = null;

export function initChatSocket(token: string): Socket {
  if (!socket) {
    socket = io(WS_CHAT_BASE_URL, {
      autoConnect: true,
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      auth: {
        token,
      },
    });

    socket.on("connect", () => {
      console.log("Socket connected", socket?.id);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connect error:", error);
    });
  } else {
    socket.auth = { token };
    if (!socket.connected) {
      socket.connect();
    }
  }

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
}

export function getChatSocket(): Socket | null {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

/**
 * Stop socket reconnection attempts and disconnect.
 * Used when session expires to prevent continuous reconnection loops.
 */
export function stopSocketReconnection() {
  if (socket) {
    socket.io.opts.reconnection = false;
    socket.disconnect();
    socket = null;
  }
}
